import React, { FC } from 'react';
import styles from './ActionModal.module.scss';

import { ModalWithAside, ShouldRender } from 'src/components';
import ActionContent from './components/ActionContent';
import { WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';

type TActionModalProps = {
  action: WORKSPACE_ACTIONS;
  title: string;
  deleteText: string;
  isOpen: boolean;
  onToggleModal: () => void;
  onConfirm: () => void;
  onClose: () => void;
  onErrorClick: () => void;
  errorMsg: string | null;
  inputValue?: Record<string, string>;
  nameValue?: string;
};

const ActionModal: FC<TActionModalProps> = ({
  action,
  deleteText,
  isOpen,
  onToggleModal,
  onClose,
  onConfirm,
  errorMsg,
  title,
  inputValue,
  onErrorClick,
  nameValue
}) => {
  return (
    <ModalWithAside isOpen={isOpen} onToggle={onToggleModal}>
      <ShouldRender should={!!action || !!errorMsg}>
        <div className={styles.container}>
          <h2 className={styles.title}>{title}</h2>

          <div className={styles.divider} />

          <ActionContent
            onClose={onClose}
            action={action}
            onConfirm={onConfirm}
            isError={!!errorMsg}
            errorMessage={errorMsg}
            deleteText={deleteText}
            inputValue={inputValue}
            onErrorClick={onErrorClick}
            nameValue={nameValue}
          />
        </div>
      </ShouldRender>
    </ModalWithAside>
  );
};

export default ActionModal;
